<template>
  <el-row class="top-bar" :class="{ 'top-bar--transparent': isTransparent }">
    <el-col :span="24">
      <div class="top-bar-container">
        <!-- 移动端下拉菜单 -->
        <el-dropdown class="mobile-menu" trigger="click" @command="handleMenuClick">
          <span class="mobile-menu-trigger">
            <i class="el-icon-menu"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="home" :class="{ 'is-active': $route.name === 'home' }">
              <span @click="navigateTo('/home')">Home</span>
            </el-dropdown-item>
            <el-dropdown-item command="news" :class="{ 'is-active': $route.name === 'news' }">
              <span @click="navigateTo('/news')">News</span>
            </el-dropdown-item>
            <el-dropdown-item command="services" :class="{ 'is-active': $route.name === 'services' }">
              <span @click="navigateTo('/services')">Services</span>
            </el-dropdown-item>
            <el-dropdown-item command="guides" :class="{ 'is-active': $route.name === 'guides' }">
              <span @click="navigateTo('/guides')">Guides</span>
            </el-dropdown-item>
            <el-dropdown-item command="about" :class="{ 'is-active': $route.name === 'about' }">
              <span @click="navigateTo('/about')">About</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <!-- Logo -->
        <router-link class="logo" to="/home">
          <img src="@/assets/images/logo.png" alt="Liveo Logo" />
        </router-link>

        <!-- 桌面端菜单项 -->
        <el-menu class="el-menu-demo desktop-menu" mode="horizontal" background-color="transparent" text-color="#000"
          active-text-color="#0355D5" :default-active="$route.name">
          <el-menu-item index="home">
            <router-link to="/home">Home</router-link>
          </el-menu-item>
          <el-menu-item index="news">
            <router-link to="/news">News</router-link>
          </el-menu-item>
          <el-menu-item index="services">
            <router-link to="/services">Services</router-link>
          </el-menu-item>
          <el-menu-item index="guides">
            <router-link to="/guides">Guides</router-link>
          </el-menu-item>
          <el-menu-item index="about">
            <router-link to="/about">About</router-link>
          </el-menu-item>
        </el-menu>

        <!-- 下载按钮 -->
        <el-button class="download-btn" type="primary" round @click="handleDownload"
          :style="{ backgroundColor: '#0355D5', borderColor: '#0355D5', color: isTransparent ? '#fff' : '#fff', padding: '12px 20px' }">
          Download App
        </el-button>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'TopBar',
  props: {
    isTransparent: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleDownload() {
      this.$router.push('/downloadApp');
    },
    handleMenuClick(command) {
      // 下拉菜单点击处理，路由跳转由 router-link 处理
    },
    navigateTo(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
.top-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.top-bar--transparent {
  background-color: transparent !important;
  box-shadow: none !important;
}

.top-bar-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15%;
  background-color: transparent;
}

.el-menu-demo {
  display: flex;
  align-items: center;
  border-bottom: none !important;
  flex-grow: 0;
  background-color: transparent !important;
}

.logo img {
  height: 40px;
  vertical-align: middle;
}

.el-menu-item {
  padding: 0px;
  height: 100%;
  display: flex;
  align-items: center;
  border-bottom: none !important;
  /* 确保任何状态下都没有下划线 */
}

/* 移除 hover 样式 */
.el-menu-item:hover,
.el-menu-item:focus {
  background-color: transparent !important;
  color: #000 !important;
}

/* 选中状态只改变字体颜色 */
.el-menu-item.is-active {
  background-color: transparent !important;
  color: #0355D5 !important;
  border-bottom: none !important;
  /* 确保选中时无下划线 */
}

/* 防止切换时非激活项出现下划线 */
.el-menu-item:not(.is-active) {
  border-bottom: none !important;
}

/* 防止 :active 伪类导致下划线 */
.el-menu-item:active {
  border-bottom: none !important;
}

.el-menu-item a {
  text-decoration: none;
  display: block;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 15px;
  color: inherit;
}

/* 确保 a 标签无额外样式 */
.el-menu-item a:hover,
.el-menu-item a:focus,
.el-menu-item a:active {
  text-decoration: none !important;
  color: inherit !important;
}

.el-button {
  border-radius: 20px;
  padding: 8px 20px;
  transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;
}

/* 大屏幕适配 */
@media (max-width: 1200px) {
  .top-bar-container {
    padding: 0 5%;
  }

  .el-menu-item a {
    padding: 0px 12px;
  }

  .download-btn {
    padding: 10px 18px !important;
    font-size: 14px;
  }
}

/* 中等屏幕/平板适配 */
@media (max-width: 992px) {
  .top-bar-container {
    padding: 0 4%;
  }

  .logo img {
    height: 36px;
  }

  .el-menu-item a {
    padding: 0px 10px;
    font-size: 14px;
  }

  .download-btn {
    padding: 10px 16px !important;
    font-size: 13px;
  }
}

/* 移动端响应式设计 */
@media (max-width: 768px) {
  .top-bar {
    min-height: 60px;
    display: flex;
    align-items: center;
  }

  .top-bar-container {
    padding: 10px 4vw;
    flex-wrap: nowrap;
    align-items: center;
    height: 100%;
    min-height: 60px;
  }

  /* 显示移动端菜单 */
  .mobile-menu {
    display: flex;
    align-items: center;
    margin-right: 15px;
    flex-shrink: 0;
    height: 100%;
  }

  .mobile-menu-trigger {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    font-size: 20px;
    color: #181818;
    cursor: pointer;
  }

  .mobile-menu-trigger:hover {
    color: #0355D5;
  }

  .logo {
    flex-shrink: 0;
    margin-right: auto;
    display: flex;
    align-items: center;
    height: 100%;
  }

  .logo img {
    height: 30px;
    vertical-align: middle;
  }

  /* 隐藏桌面端菜单 */
  .desktop-menu {
    display: none !important;
  }

  /* 下拉菜单项样式 */
  .mobile-menu :deep(.el-dropdown-menu__item) {
    padding: 12px 20px;
  }

  .mobile-menu :deep(.el-dropdown-menu__item span) {
    display: block;
    width: 100%;
    color: #181818;
    cursor: pointer;
  }

  .mobile-menu :deep(.el-dropdown-menu__item.is-active span),
  .mobile-menu :deep(.el-dropdown-menu__item:hover span) {
    color: #0355D5;
  }

  .download-btn {
    padding: 8px 16px !important;
    font-size: 12px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    height: auto;
  }
}

/* 小移动端适配 */
@media (max-width: 600px) {
  .top-bar {
    min-height: 56px;
  }

  .top-bar-container {
    padding: 8px 4vw;
    min-height: 56px;
  }

  .mobile-menu {
    margin-right: 12px;
  }

  .mobile-menu-trigger {
    width: 28px;
    height: 28px;
    font-size: 18px;
  }

  .logo img {
    height: 28px;
  }

  .download-btn {
    padding: 6px 12px !important;
    font-size: 11px;
  }

  .mobile-menu :deep(.el-dropdown-menu__item) {
    padding: 10px 16px;
    font-size: 14px;
  }
}

/* 桌面端隐藏移动端菜单 */
@media (min-width: 769px) {
  .mobile-menu {
    display: none !important;
  }
}
</style>